export enum ShippingMethodTypes {
    CLICK_AND_COLLECT = "CC",
    HOME_DELIVERY = "HD",
    JAPAN_CLICK_AND_COLLECT = "JP-CC",
}

export interface ShippingMethod {
    key: string;
    marketKey: string;
    type: ShippingMethodTypes;
}

export const DELIVERY_METHODS_DICTIONARY: Record<string, ShippingMethod[]> = {
    "jp.ecco.com": [{ key: "CC", marketKey: "JP-CC", type: ShippingMethodTypes.CLICK_AND_COLLECT }],
};

export type TPaymentMethods = {
    name: string;
    type: string;
    brands?: string[];
    configuration?: object;
};

export type TPaymentResponse = {
    resultCode: string;
    action?: string;
};

export type TOrderResponse = {
    orderId?: string;
    resultCode?: string;
    orderState?: object;
    message?: string;
};
